<template>
  <div class="flags">
    <!-- <v-check :label="'Compo'" v-model="general.isCompo"/> -->
    <!-- <v-check :label="'Base dressing'" :disabled="true" v-model="general.isBaseDressing"/> -->
    <!-- <v-check :label="'Soil Grown'" :disabled="true" v-model="general.isSoilGrown"/> -->
    <!-- <v-check :label="'Hydroponic'" :disabled="true" v-model="general.isHydroponic"/> -->
    <v-check
      :label="$ml.get(`Compound`)"
      v-model="general.isCompound"

    />
    <v-check
      :label="$ml.get(`Manure`)"
      v-model="general.isManureFertilizer"
      :disabled="general.stateId == 5 || general.stateId == 6"
      v-show="false"
    />
    <v-check
      :label="$ml.get(`Mark if microelements are chelated`)"
      v-model="general.data.MicroElementsChelated"
      :disabled="general.stateId == 2"
    />
  </div>
</template>

<script>
export default {
  props: {
    general: Object
  }
}
</script>

<style lang="scss" scoped>
  .flags {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    > div {
      margin: 0 15px;
    }
  }
</style>
